<template>
  <div class="ui grid" v-if="!isGuest">
    <div class="row">
      <h1 class="ui huge header">Training</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <div class="ui divided items">
        <div class="item">
          <div class="image">
            <!-- eslint-disable-next-line max-len -->
            <a target="_blank" href="static/PD1/index.html"><i class="massive file powerpoint icon"></i></a>
          </div>
          <div class="content">
            <div class="header">Session 1 - Sociometry</div>
            <div class="description">
              <ul>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  Introduction to the science of sociometry and the sociometric
                  instrument created by the Helping Hands ABP
                </li>
                <ul>
                  <li>How to implement it</li>
                  <li>What it can achieve</li>
                </ul>
                <li>
                  The sociometric categories created by Coie et al., (1982)
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  Understanding the ‘sociodynamic effect’ – being unchosen in
                  the context of unlimited nominations
                </li>
                <li>Interpreting the sociometric results</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <!-- eslint-disable-next-line max-len -->
            <a target="_blank" href="static/PD2/index.html"><i class="massive file powerpoint icon"></i></a>
          </div>
          <div class="content">
            <div class="header">
              Session 2 - The nature and dynamics of hidden bullying
            </div>
            <div class="description">
              <ul>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The inner worlds of the targets (victims), the perpetrators
                  (students who bully) and bystanders in (peer group) bullying
                  situations
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The compelling reasons why all three groups collude to keep
                  bullying hidden from teachers, parents, school authorities
                  even when it is completely visible in the peer group
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The power of sociometry to penetrate this hidden world of
                  denial
                </li>
              </ul>
              <a target="_blank" href="static/sessions/Session 2 - Case Study 1 Phil.docx"><i
                  class="large file word icon"></i>Case Study 1 Phil</a>
              <a target="_blank" href="static/sessions/Session 2 - Recorder for Case Study 1 Phil.docx"><i
                  class="large file word icon"></i>Recorder for Case Study 1
                Phil</a>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <!-- eslint-disable-next-line max-len -->
            <a target="_blank" href="static/PD3/index.html"><i class="massive file powerpoint icon"></i></a>
          </div>
          <div class="content">
            <div class="header">
              <!-- eslint-disable-next-line max-len -->
              Session 3 - The two types of empathy (Cognitive and Affective),
              and how each relate to bullying
            </div>
            <div class="description">
              Distinguishing between perpetrators and targets:
              <ul>
                <!-- eslint-disable-next-line max-len -->
                <li>Their similar and different behaviours</li>
                <!-- eslint-disable-next-line max-len -->
                <li>Hostile attributional bias and self-attributional bias</li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  Difference between being <i>‘popular’</i> and being
                  <i>‘liked’</i>
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  Difference between being <i>‘disliked’</i> and
                  <i>‘excluded’</i>
                </li>
              </ul>
              The transfer of bullying from Primary to Secondary School<br /><br />
              <a target="_blank" href="static/sessions/Session 3 - Reflection on Empathy.docx"><i
                  class="large file word icon"></i>Reflection on Empathy</a>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <!-- eslint-disable-next-line max-len -->
            <a target="_blank" href="static/PD4/index.html"><i class="massive file powerpoint icon"></i></a>
          </div>
          <div class="content">
            <div class="header">
              <!-- eslint-disable-next-line max-len -->
              Session 4 - Recognising and responding to hidden bullying -
              challenges for schools, teachers, parents
            </div>
            <div class="description">
              <ul>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The necessary focus in the classroom of overt behaviour that
                  promotes learning and the challenges this poses for teachers
                  in recognising hidden bullying
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The impact of the organisational structure of the school
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  The impact of parental distress – how it militates against
                  reporting
                </li>
              </ul>
              <a target="_blank" href="static/sessions/Session 4 - Case Study 2 Leanne.docx"><i
                  class="large file word icon"></i>Case Study 2 Leanne</a>
              <a target="_blank" href="static/sessions/Session 4 - Case Study 3 Cian.docx"><i
                  class="large file word icon"></i>Case Study 3 Cian</a>
              <a target="_blank" href="static/sessions/Session 4 - Case Study 4 Tim & Karl.docx"><i
                  class="large file word icon"></i>Case Study 4 Tim & Karl</a>
              <a target="_blank" href="static/sessions/Session 4 - Three Step Interview for CS 2 Leanne.docx"><i
                  class="large file word icon"></i>Three Step Interview for CS
                2 Leanne</a>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <!-- eslint-disable-next-line max-len -->
            <a target="_blank" href="static/PD5/index.html"><i class="massive file powerpoint icon"></i></a>
          </div>
          <div class="content">
            <div class="header">
              <!-- eslint-disable-next-line max-len -->
              Session 5 - Resolution of bullying through empowerment of victims
            </div>
            <div class="description">
              <ul>
                <!-- eslint-disable-next-line max-len -->
                <li>
                  Creating conditions that make it safe for victims to ‘tell’
                </li>
                <!-- eslint-disable-next-line max-len -->
                <li>The process of empowerment of victims / targets</li>
                <!-- eslint-disable-next-line max-len -->
                <li>Handling and helping the perpetrator</li>
                <!-- eslint-disable-next-line max-len -->
                <li>Limitations of the investigative approach</li>
                <!-- eslint-disable-next-line max-len -->
                <li>The impact of the Cooperative Learning Classroom</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Training',
  components: {},
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isGuest: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Guest');
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Training.vue